/**
 * Finds a pending interpreter request by id across the active popup request
 * and the minimized list.
 *
 * The interpreter accept/decline handlers must act on the request the button
 * belongs to — NOT on whatever happens to be in `currentRequest` at click
 * time. When a second request arrives it becomes `currentRequest` and the
 * first is pushed to the minimized list; accepting the minimized one while
 * reading `currentRequest.roomName` would send the accept for the wrong room
 * (or an undefined room once the popup is cleared), so the client is never
 * routed into the interpreter's call.
 *
 * @param {string} requestId - The id from the accept/decline button.
 * @param {InterpreterRequest|null} currentRequest - The popup request.
 * @param {InterpreterRequest[]} minimizedRequests - The minimized list.
 * @returns {InterpreterRequest|undefined} The matching request, if any.
 */
export function resolveQueueRequest(requestId, currentRequest, minimizedRequests = []) {
    if (currentRequest && currentRequest.id === requestId) {
        return currentRequest;
    }
    return minimizedRequests.find(request => request.id === requestId);
}
